import { useMemo } from 'react'
import styled from 'styled-components'
import { useLocation } from 'react-router-dom'
import { Flex, useMatchBreakpoints } from 'vvs-uikit'
import { useTranslation } from 'contexts/Localization'
import getVvsGotchiMenuConfig from 'components/Menu/VvsGotchiMenu/config'
import { getActiveMenuItemStartsWithOrHome } from 'components/Menu/utils'
import GamifiedButton from './GamifiedButton'

interface Cloud {
  x: number
  y: number // in percentage
  size: number // height in pixel
}
const CLOUDS: Cloud[] = [
  { x: -2, y: 20, size: 50 },
  { x: 10, y: 53, size: 31 },
  { x: 0, y: 75, size: 55 },
  { x: 97, y: 28, size: 31 },
  { x: 90, y: 53, size: 50 },
  { x: 85, y: 83, size: 50 },
]

const VvsGotchiConsole: React.FC = ({ children }) => {
  const { t } = useTranslation()
  const { isMobile } = useMatchBreakpoints()
  const location = useLocation()

  const menuConfig = useMemo(() => getVvsGotchiMenuConfig(t), [t])

  if (isMobile) return <>{children}</>

  const activeMenuItem = getActiveMenuItemStartsWithOrHome({ menuConfig, pathname: location.pathname })

  return (
    <SkyBg clouds={CLOUDS}>
      <ConsoleFlex justifyContent="center" height="100vh" pt={3}>
        <Flex alignItems="center" alignSelf="center" flexDirection="column" minWidth="570px">
          <Flex width="100%" justifyContent="center" gap="24px" mb={3}>
            {menuConfig.map(({ label, IconComponent, href }) => (
              <GamifiedButton
                key={label}
                label={label}
                IconComponent={IconComponent}
                href={href}
                isActive={href === activeMenuItem.href}
              />
            ))}
          </Flex>

          {children}
        </Flex>
      </ConsoleFlex>
    </SkyBg>
  )
}

export default VvsGotchiConsole

const SkyBg = styled.div<{ clouds: Cloud[] }>`
  background-image: ${({ clouds }) =>
    [...clouds.map(() => 'url("/images/vvsGotchi/sky_cloud.png")'), 'url("/images/vvsGotchi/bg_sky.png")'].join(', ')};
  background-size: ${({ clouds }) => [...clouds.map((c) => `${c.size * 5}px ${c.size}px`), 'cover'].join(', ')};
  background-position: ${({ clouds }) => [...clouds.map((c) => `${c.x}% ${c.y}%`), 'center'].join(', ')};

  height: 100vh;
  background-repeat: no-repeat;
  image-rendering: pixelated;
`
const ConsoleFlex = styled(Flex)`
  background-image: url('/images/vvsGotchi/console.png');
  background-position: center;
  background-size: auto 1080px;
  background-repeat: no-repeat;
  padding-top: 0px;
  image-rendering: auto;
`
